import React, { useState, useEffect } from 'react';
import { Form, Input } from '@rocketseat/unform';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import history from '~/services/history';

// 1. Importando o logo e os backgrounds
import logo from '~/assets/Logo Apolar-pretaeazul01.png';
import backgroundMobile from '~/assets/apolino-bg-mobile.jpg';
import backgroundDesktop from '~/assets/apolino-bg-desktop.webp';

// 2. Importando o MobileLayout e GlobalFonts junto com Content e Loader
import { Content, Loader, MobileLayout, GlobalFonts } from '~/pages/SignIn/styles';
import { signInRequest } from '~/store/modules/auth/actions';
import vetorTartaruga from '~/assets/vetor-tartaruga.png';

const schema = Yup.object().shape({
  password: Yup.string().required(
    'É obrigatório preencher sua senha para seguir.'
  ),
});

export default function Login() {
  const dispatch = useDispatch();
  const loading = useSelector(state => state.auth.loading);

  const [name, setName] = useState('');
  const [document, setDocument] = useState('');
  const [password, setPassword] = useState('');

  useEffect(() => {
    setName(localStorage.getItem('name'));
    setDocument(localStorage.getItem('document'));
  }, [loading]);

  async function handleSubmit() {
    //window.localStorage.setItem("_secret_", btoa(`4P0${btoa(`${document};${password}`)}`))
    dispatch(signInRequest(document, password));
  }

  return (
    <>
      {/* 3. Adicionando fontes globais e o Wrapper com os backgrounds */}
      <GlobalFonts />
      <MobileLayout bgMobile={backgroundMobile} bgDesktop={backgroundDesktop}>
        
        <Content>
          <img src={vetorTartaruga} style={{ width: '40px' }} alt="Logo Apolar Imóveis" />
          <Loader style={{ display: loading ? 'block' : 'none' }} />
          
          <Form schema={schema} onSubmit={handleSubmit}>
            <h2 className='login-page'>{name}</h2>
            <div className="cpf">CPF: {document}</div>

            <div className="inputPassword">
              <strong className="labelLogin">Digite a sua senha.</strong>
              <Input 
                maxLength="100"
                name="password"
                type="password"
                placeholder="Digite sua senha"
                style={{ width: '100%' }}
                value={password}
                onChange={e => setPassword(e.target.value)}
              />
            </div>
            
            <div className="buttons">
              <button type="submit" class="btn-proximo">Próximo</button>

              <a href="javascript:void(0)" onClick={() => history.push('/RecuperarSenha')} id="forgetPassword">
                Esqueceu a senha?
              </a>
            </div>
          </Form>
        </Content>

      </MobileLayout>
    </>
  );
}